import { API } from "../../utils/_HttpUtils";


function impersonateExit() {
    return new API().send("POST", "/core/impersonations/manager/leave");
}

export { impersonateExit };
